// extracted by mini-css-extract-plugin
export default {"popupStyle":"ToastMessage_popupStyle__Y14h6"};